import { Component } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { CustomerEditService } from '../../services/customer-edit/customer-edit.service';
import { ApiService } from '../../services/api/api.service';
import { FormValuesService } from '../../services/form-values/form-values.service';
import { QuestionService } from '../../services/question/question.service';



@Component({
  selector: 'app-customer-edit',
  templateUrl: './customer-edit.component.html',
  styleUrls: ['./customer-edit.component.css']
})
export class CustomerEditComponent {
  
  private questions;
  private dynamicQuestions;
  private formNew: boolean = true;

  constructor(
    private questionService: QuestionService,
    private router: Router,
    private route: ActivatedRoute,
    private formValueService: FormValuesService,
    private apiService: ApiService,
    private customerEditService: CustomerEditService
  ){ 
  }
    
}



// WEBPACK FOOTER //
// ./src/app/customer-overview/customer-edit/customer-edit.component.ts